"use client";
import React, { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { cn } from '../lib/utils';
import { Menu, X, Globe, Mail, Phone } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';

import Navbar from './Navbar';
import wechatImg from '../assets/img/team/wechat.png';
import footerLogoImg from '../assets/img/footer-logo-white.png';

const Layout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [pathname]);

  return (
    <div className="min-h-screen flex flex-col bg-slate-50 text-slate-800 font-sans selection:bg-blue-100 italic-none">
      <Navbar />

      {/* Main Content */}
      <main className="flex-grow">
        {children}
      </main>

      {/* Footer */}
      <footer className="bg-[#0A0D15] text-slate-400 pt-20 pb-10 px-6 lg:px-12 border-t border-white/5 italic-none">
        <div className="max-w-[1400px] mx-auto grid grid-cols-1 md:grid-cols-4 gap-16">
          <div className="space-y-6">
            <Link
              to="/"
              aria-label="返回前排科技首页"
              className="inline-flex"
            >
              <img
                src={footerLogoImg}
                alt="前排科技 Front Row Technology"
                className="h-16 w-auto object-contain"
              />
            </Link>
            <p className="text-sm leading-relaxed text-slate-500">
              前排科技（武汉）有限公司，专业深耕企业级GEO优化服务，旗下前排GEO系统，提供全域GEO优化服务。前排GEO团队深耕AI与人工智能搜索优化领域多年，专注于为品牌商提供专业的GEO解决方案。
            </p>
          </div>
          
          <div>
            <h4 className="font-bold text-white mb-6">快速导航</h4>
            <ul className="space-y-4 text-sm">
              <li><Link to="/faq" className="hover:text-white transition-colors">GEO常见问题</Link></li>
              <li><Link to="/services" className="hover:text-white transition-colors">GEO优化服务</Link></li>
              <li><Link to="/cases" className="hover:text-white transition-colors">GEO成功案例</Link></li>
              <li><Link to="/knowledge" className="hover:text-white transition-colors">GEO 知识库</Link></li>
              <li>
                <Link
                  to="/about"
                  onClick={() => window.scrollTo({ top: 0, left: 0, behavior: 'auto' })}
                  className="transition-colors hover:text-white"
                >
                  联系我们
                </Link>
              </li>
              <li><Link to="/compliance" className="text-red-500 font-bold">合规声明</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-bold text-white mb-6">扫码获取免费AI-GEO优化诊断报告</h4>
            <div className="p-2 bg-white w-32 h-32 rounded-xl flex items-center justify-center">
               <img
                src={wechatImg}
                alt="WeChat QR Code"
                className="w-28 h-28 object-contain rounded-lg"
              />
            </div>
          </div>

          <div>
            <h4 className="font-bold text-white mb-6">联系我们</h4>
            <ul className="space-y-4 text-sm">
              <li className="flex items-start gap-3">
                <div className="text-blue-500 mt-1">📍</div>
                <span>湖北省武汉市东湖高新技术开发区光谷大道35号光谷总部时代1栋1403室</span>
              </li>
              <li className="flex items-center gap-3">
                <div className="text-blue-500">📞</div>
                <span>15871690626 (微信同号)</span>
              </li>
              <li className="flex items-center gap-3">
                <div className="text-blue-500">✉️</div>
                <span>277048401@qq.com</span>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="max-w-[1400px] mx-auto mt-10 pt-8 border-t border-white/5 flex flex-col md:flex-row justify-between items-center text-[10px] text-slate-600 gap-4">
          <p>本网站归属于前排科技（武汉）有限公司，武汉市GEO优化服务商前排科技官方网站。</p>
          <div className="flex gap-4">
            <span>© 2026 . 版权所有 前排GEO团队·前排科技（武汉）有限公司</span>
            <a
              href="https://beian.miit.gov.cn/#/Integrated/index"
              target="_blank"
              rel="noreferrer noopener"
              className="hover:text-white"
            >
              鄂ICP备2026037852号-1
            </a>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Layout;
